import React from 'react';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import AppVariables from "./AppVariables";
import sessions from "../sessions";
import TractorUtils from '../views/Tractors/TractorUtils';
import TimeAgo from 'javascript-time-ago';
import _ from 'lodash';
import history from '../history';
import GoogleLibPhoneNumber from 'google-libphonenumber';
import ReactDOM from 'react-dom';
// Load locale-specific relative date/time formatting rules.
import en from 'javascript-time-ago/locale/en';
import {ResponseStatus, UserRoles} from "./Constants";

import TurnDownService from 'turndown';
import TTLProxy from "./TTLAsyncProxy";


// Add locale-specific relative date/time formatting rules.
TimeAgo.locale(en);

const timeAgo = new TimeAgo("en-us");
const PNF = GoogleLibPhoneNumber.PhoneNumberFormat;
const phoneUtils = GoogleLibPhoneNumber.PhoneNumberUtil.getInstance();

//
const turnDownService = new TurnDownService();

/**
 * The default preferred way of formatting standard dates
 * @type {string}
 */
export const StandardDateFormat = "MMMM D, YYYY H:mm A";

/**
 * The default preferred way of formatting long dates
 * @type {string}
 */
export const StandardDateFormatLong = "MMMM D, YYYY H:mm A";

/**
 * The default preferred way of formatting short dates
 * @type {string}
 */
export const StandardDateFormatShort = "MMMM D, YYYY";

const paramString = (values) => {
    let queryParams = "";
    if (Array.isArray(values)) {

        values.map((value, index) => {
            let joinBy = "";
            if(index > 0)
                joinBy = ",";

            return queryParams += joinBy + encodeURIComponent(value);
        });

    } else {
        queryParams += encodeURIComponent(values);
    }
    return queryParams;
};


/**
 * A placeholder for error states
 */
class ErrorState {

    state;
    constructor(state){
        this.state = state;
    }
}

export function downloadBlob(blob,filename) {

    if (navigator.msSaveBlob) {
        // Internet Explorer throws "Access is Denied" with ObjectUrls
        navigator.msSaveBlob(blob, filename);
        return;
    }

    const link = document.createElement("A");
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = filename;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

/**
 * Detects whether the object instance is a CRUDView
 * @param instance
 * @returns {boolean}
 */
export function isCRUDView(instance) {
    return instance && instance.props && instance.props.hasOwnProperty('__isCRUDView') && instance.props.__isCRUDView === true;
}

/**
 * Search text with keyword
 * @param text
 * @param kwd
 * @returns {boolean}
 */
export const containsText = (text, kwd) => {
    return text.toLowerCase().indexOf(kwd.toLowerCase()) >= 0;
};

/**
 * Process CSV export
 */
export function exportCSV(endpoint) {
    const proxy = TTLProxy.getInstance();
    window.open(proxy.getUrl((_.isString(endpoint.url) ? endpoint.url : endpoint) + `?access_token=${encodeURIComponent(proxy.getAuthInfo().token) }&api_key=${ encodeURIComponent(proxy.apiKey) }`) );
}

/**
 * Processes filtered CSV export
 * @param endpoint Endpoint
 * @param {Object} component CRUD view component
 * @param {Object|undefined} queryParams Custom query params
 * @param {Function|undefined} queryHook Custom query hook
 */
export function exportFilteredCSV(endpoint , { component , queryParams , queryHook }) {

    const proxy = TTLProxy.getInstance();

    if(isCRUDView(component)){
        queryParams =   component.getQueryParams({});
        queryHook = _.isFunction(component.onExecuteRequest) ? (url,params) => component.onExecuteRequest(url,params,component.getQueryFilters()) : null;
    }

    let params = queryParams;
    if(queryHook){
        queryHook(endpoint.url,params);
    }

    //  remove pagination
    const { pagination  , ...exportParams } = params;

    window.open(proxy.buildQueryString({
        ...endpoint,
        ...exportParams
    }));
}

/**
 * Gets default map center
 * @return {{lng: number, lat: number}}
 */
export function getDefaultMapCenter() {

    if(!process.env.REACT_APP_MAP_DEFAULT_CENTER_COORDS)
        return AppVariables.DefaultMapCoordinates;

    const _coords = process.env.REACT_APP_MAP_DEFAULT_CENTER_COORDS.split(",");
    return { lat: Number(_coords[0]) , lng: Number(_coords[1]) };
}

/**
 * Run steps
 * @returns {Promise<{step: number, isComplete: boolean}>}
 */
export const runStepAsync = async (step,state,values,steps) => {

    let result = {};

    while (step < steps.length) {

        const _step = steps[step];

        try {

            if(!await _step.run(values,state)){
                break;
            }

        }
        catch (e) {
            console.error(`[STEP-ERROR: ${_step.key}]\r\n`,e);
            result.error = e;
            break;
        }

        step++
    }

    result.step = step;
    result.isComplete = step >= steps.length;
    result.state = state;

    return result;
};

export const findMediaWithTag = (media,tag) => {
    let _media = media.sources.find(x => x.tag === tag);
    return _media ? _media.path.static : null;
};

export default class Utils {

    static errorState(state){
        return new ErrorState(state);
    }

    static validateImageFile(file,maxFileSize = 5242880) {

        if(!file.type.match(/image.*/)){
            window.alert('Please select a valid image file');
            return false;
        }

        if(file.size > maxFileSize){
            window.alert('Select image too big!');
            return false;
        }

        return true;
    }

    static readFile(file) {

        return new Promise((resolve, reject) => {

            const reader = new FileReader();

            // Read the image via FileReader API and save image result in state.
            reader.onload = function (e) {

                // Add the file name to the data URL
                let dataURL = e.target.result;
                dataURL = dataURL.replace(";base64", `;name=${file.name};base64`);
                resolve({file, dataURL});
            };

            reader.readAsDataURL(file);
        });

    }

    static formatTimeAgo(date){
        return timeAgo.format(date);
    }

    static exceptionToFormErrors(err,nameMapping){

        const response = err.response;
        const errorPayload =  { };
        let statusError;

        //  BAD_REQUEST ??
        if(response && response.body && response.status === 400){

            const body = response.body;
            if(body.status === ResponseStatus.ValidationError && body.error.detail.length > 0){

                const detail = body.error.detail;

                //  find associated fields and flag them
                detail.forEach(f => {

                    const field = f.field;
                    let input = nameMapping ? nameMapping[field] : field;
                    if(input){
                        errorPayload[input] = f.message;
                    }


                });

                if(detail.length === 1) {
                    statusError = detail[0].message;
                }
                else{
                    statusError = 'Failed: Some fields were invalid. Please fix and try again.';
                }

                return { errors: errorPayload , statusMessage: statusError };

            }

        }

    }

    /**
     * Converts html element or string to markdown
     * @param html
     * @returns {*}
     */
    static htmlToMarkdown(html){
        return turnDownService.turndown(html);
    }

    static isErrorState(state){
        return state instanceof ErrorState;
    }

    // convert Hex to RGBA
    static convertHex(hex,opacity) {

        hex = hex.replace('#','');
        var r = parseInt(hex.substring(0,2), 16);
        var g = parseInt(hex.substring(2,4), 16);
        var b = parseInt(hex.substring(4,6), 16);

        return 'rgba('+r+','+g+','+b+','+opacity/100+')';
    }

    /**
     * Validates a phone number
     * @param phoneNumber The phone number to validate
     * @param region The region to use for validation. Will default to environment specified region code if not specified
     * @returns {boolean}
     */
    static validatePhoneNumber(phoneNumber , region){

        try{
            let _number = phoneUtils.parse(phoneNumber,region || AppVariables.CountryPhoneRegionCode);
            return phoneUtils.isPossibleNumber(_number);
        }
        catch(ex) {
            return false;
        }

    }

    /**
     * Replace keys in object
     */
    static replaceKeys(object, replace){

        if(Object.keys(replace || {}).length === 0)
            return  object;

        let result = {};
        Object.keys(object).forEach(k => {

            //
            if(replace.hasOwnProperty(k))
                result[k] = replace[k];
            else
                result[k] = object[k];
        });

        return result;
    }

    /**
     * Checks whether the place input has valid values
     * @param place
     * @returns {boolean}
     */
    static isValidPlace(place){

        if(!place.text){
            return false;
        }

        return true;
    }

    /**
     * Gets the formatted standard value for display
     * @param val
     * @returns {*}
     */
    static standardValue(val){

        if( ( (typeof val === "string"  && val.trim() === '')  || val === null || val === undefined) && val !== 0)
            return "N/A";

        return val;
    }


    /***
     * Checks whether the supplied object is a valid location object
     * @param loc
     * @returns {*|boolean}
     */
    static isValidLocation(loc){
        return loc && loc.lat != null && loc.lng != null &&  (loc.lat >= -90 && loc.lat <= 90) && (loc.lng >= -180 && loc.lng <= 180 );
    }

    /**
     * Focuses and select all text in supplied input
     * @param input
     */
    static flashInput(input){

        if(!input){
            return;
        }

        if(input.focus)
            input.focus();

        if(input.select)
            input.select();
    }

    /**
     * Returns an appropriate color to represent a percentage value
     * @param percentage
     * @returns {*}
     */
    static getPercentageColor(percentage){
        if(percentage >=0 && percentage <= 29)
            return "danger";
        else if(percentage >= 30 && percentage < 69)
            return "warning";
        else{
            return "success";
        }
    }

    /**
     * Validates activation token length
     * @param activationCode
     * @returns {boolean}
     */
    static validateActivationCode(activationCode){

        if(!activationCode || (AppVariables.ValidTokenLengths.indexOf(activationCode) < 0))
            return false;

        return true;
    }

    /**
     * Format name for avatar display
     * @param name
     * @param maxWords
     * @returns {string}
     */
    static formatAvatarName(name , maxWords = 2){

        name = name.replace("  ", " ")
            .replace("(", "")
            .replace(")", "").trim();

        //
        let i = 0;
        let c = 0;
        let k = 0;
        while (c++ < maxWords && i < name.length) {

            k = name.indexOf(" ", i + 1);
            if (k < 0) {
                break;
            }

            //
            i = k;
        }

        return c > maxWords ? name.substring(0, i) : name;
    }

    /**
     * Formats A Standard Tractor Name
     * @param tractor
     * @param withState
     * @param includeChassis
     * @returns {string}
     */
    static formatTractorName(tractor,withState = false,includeChassis = true){


        let name = `${tractor.name} (${tractor.chassis})`;
        if(includeChassis){
            name += ` - ${tractor.registration_number}`;
        }

        if(withState){
            return <span>{name} {TractorUtils.renderState(tractor)}</span>
        }
        return name;
    }

    static measureElement(element) {
        const DOMNode = ReactDOM.findDOMNode(element);
        return {
            width: DOMNode.offsetWidth,
            height: DOMNode.offsetHeight,
        };
    }

    static paginate(items, skip , limit){

        let filtered = [];
        if(skip === undefined){
            filtered = items;
        }
        else{
            filtered = _.takeRight(items,items.length - skip);
        }

        if(limit !== undefined){
            filtered = _.take(filtered,limit);
        }

        return filtered;
    }

    /**
     * Format duration
     * @param start The start date
     * @param end The end date
     * @returns {string}
     */
    static formatDuration(start, end) {

        const diff = moment(end).diff(start);
        const duration = moment.duration(diff);

        function join(args) {

            let values = [];
            let accepted = args.filter(x => x.value > 0);
            for (let i = 0; i < accepted.length; i++) {
                values.push(`${accepted[i].value} ${accepted[i].unit}`);
            }

            return values.join(", ");
        }

        if (duration.minutes() === 0) {

            //  seconds
            return `${duration.seconds()} ${Utils.pluralize(duration.seconds(),"second","seconds")}`;
        }
        else if (duration.hours() === 0) {

            // minutes
            return `${duration.minutes()} ${Utils.pluralize(duration.minutes(),"minute","minutes")}`;
        }
        else if (duration.days() === 0) {

            //  hours
            return `${duration.hours()} ${Utils.pluralize(duration.hours(),"hour","hours")}`;
        }
        else if (duration.weeks() === 0) {

            //  days
            return join([
                {
                    value: duration.days(),
                    unit: Utils.pluralize(duration.days(),"day","days")
                },
                {
                    value: duration.hours(),
                    unit: Utils.pluralize(duration.hours(),"hour","hours")
                }
            ]);
        }
        else if (duration.months() === 0) {

            //  weeks
            return join([
                {
                    value: duration.weeks(),
                    unit: Utils.pluralize(duration.weeks(),'week','weeks')
                },
                {
                    value: duration.days(),
                    unit: Utils.pluralize(duration.days(),'day', 'days')
                }
            ]);

        }
        else if (duration.years() === 0) {

            return join([
                {
                    value: duration.months(),
                    unit: Utils.pluralize(duration.months(), 'month' , 'months')
                },
                {
                    value: duration.weeks(),
                    unit: Utils.pluralize(duration.weeks(),'week','weeks')
                }
            ]);

        }
        else {

            return join([
                {
                    value: duration.years(),
                    unit: Utils.pluralize(duration.years(),'year','years')
                },
                {
                    value: duration.months(),
                    unit: Utils.pluralize(duration.months() , 'month' , 'months')
                }
            ]);
        }
    }

    /**
     * Converts exception object to error payload
     * @param err
     * @param replace
     */
    static exceptionToErrors(err,replace){

        const response = err.response;

        //  BAD_REQUEST ??
        if(response && response.body && response.status === 400){

            const body = response.body;
            if(body.status === ResponseStatus.ValidationError && body.error.detail.length > 0){

                const detail = body.error.detail;

                //
                let errorPayload = { };

                //  find associated fields and flag them
                detail.forEach(f => {

                    const field = f.field;
                    if(replace.hasOwnProperty(field))
                        errorPayload[replace[field]] = f.message;
                    else
                        errorPayload[field] = f.message;

                });

                return errorPayload;
            }

        }


    }

    /**
     * Inserts a None option select
     * @param options
     * @param text
     * @param displayProperty
     */
    static insertNone(options,text = 'None',displayProperty = 'text'){
        options.splice(0,0, { value: '' , [displayProperty] : text });
        return options;
    }

    /**
     * Checks whether the error is a network connectivity error
     * @param error
     * @returns {boolean|*}
     */
    static isConnectionError(error){
        return 'isConnectionError' in error && error.isConnectionError();
    }

    /**
     * Contains
     * @param text
     * @param kwd
     * @returns {boolean}
     */
    static containsText(text,kwd){
        return (text || "").toLowerCase().indexOf((kwd || "").toLowerCase()) >= 0;
    };

    /**
     * Gets a presentable error message from response error message
     * @param error
     * @returns {*}
     */
    static getResponseError(error){

        if('isConnectionError' in error){

            if(error.isConnectionError())
                return 'Oops! Failed contacting server. Check network connectivity!';

            return error.getServerError();
        }

        return "Error: Something wen't wrong. Please try again!";
    }

    static parseNotificationData(data, callback){

        if(data.type === "array"){

            for(let i = 0 , len = data.count ; i < len ; i++){
                callback(data.model[i]);
            }

        }
        else if(data.type === "object"){
            callback(data.model);
        }

    }

    static  getUserEntity(user){

        switch (user.role){
            case UserRoles.Admin:
                return user.admin;
            case UserRoles.FBO:
                return user.fbo;
            case UserRoles.Owner:
                return user.owner;
            case UserRoles.CallCenterAgent:
                return user.call_center_agent;
            case UserRoles.Farmer:
                return  user.farmer;
        }

    }

    static getUserEntityId(user){
        return Utils.getUserEntity(user).id;
    }

    static getUserEntityMedia(user){
        return Utils.getUserEntity(user).media;
    }

    static setUserEntityMedia(user,media){
        return Utils.getUserEntity(user).media = media;
    }

    /**
     * Fix phone number
     * @param phone The phone number
     * @param region The phone number region
     */
    static fixPhone(phone,region){
        return Utils.formatPhone(phone,'e164', region || AppVariables.CountryPhoneRegionCode);
    }

    /**
     * Formats a phone number
     * @param {String} phone
     * @param {String} format The format. One of  "e164" , "international" , "national"
     * @param {String} region The default phone number region. Will default to environment phone region if not specified
     */
    static formatPhone(phone , format , region) {

        let _format;
        switch (format){
            case "e164":
                _format = PNF.E164;
                break;
            case "international":
                _format = PNF.INTERNATIONAL;
                break;
            case "national":
                _format = PNF.NATIONAL;
                break;
        }

        let number;
        try {
            number = phoneUtils.parse(phone,region || AppVariables.CountryPhoneRegionCode);
        }catch (ex){
            return phone;
        }

        return phoneUtils.format(number,_format);
    }


    /**
     * Clears the session data
     * @param keys The key to remove from the session storage
     */
    static eraseSession(keys){

        function clearFrame(frame) {

            frame.forEach(k =>{
                window.sessionStorage.removeItem(k);
            });

        }

        if(Array.isArray(keys)){

            keys.forEach(k => {

                if(sessions[k]){
                    clearFrame(sessions[k]);
                }

            });

        }
        else if(typeof keys == "string"){

            if(sessions[keys]){
                clearFrame(sessions[keys]);
            }

        }

    }

    /**
     * Gets the first name
     * @param name
     */
    static getFirstName(name){

        let s = name.indexOf(" ");
        if(s >= 0){
            return name.substring(0,s);
        }

        return name;

    }

    /**
     * Navigates to the specified link
     * @param url
     * @param evt
     */
    static navigateLink(url,evt){

        if(evt) {
            evt.stopPropagation();
            evt.preventDefault();
        }

        history.push(url);
    }

    /**
     * Concatenates the values supplied in a more readable form. Thus [ 'Ball' , 'Food' , 'Movie'] will yield Ball, Food and Movie
     * @param values
     * @returns {*}
     */
    static readableConcat(values){

        if(values.length === 1){
            return Utils.ucFirst(values[0]);
        }

        let kStore = [];
        for(let i = 0 ; i < values.length - 1 ; i++ ){
            kStore.push( Utils.ucFirst(values[i]) );
        }

        return `${kStore.join(", ")} and ${Utils.ucFirst([values[values.length - 1]])}`;
    }


    /**
     * Checks role access
     * @param role
     * @param roleCheck
     */
    static hasRole(role, roleCheck) {

        let p1 = role.split(",");

        function internalCheckRole(chk) {
            return p1.indexOf(chk) >= 0;
        }

        let checkRoles;
        if (Array.isArray(roleCheck)) {
            checkRoles = roleCheck;
        } else {
            checkRoles = roleCheck.split(",");
        }

        for (let i = 0; i < checkRoles.length; i++) {
            if (internalCheckRole(checkRoles[i])) {
                return true;
            }
        }

        return false;
    }

    /**
     * Get user profile image
     * @param media
     * @returns {*}
     */
    static getProfileImage(media,thumbnail = false){

        if(media) {

            let m = media.sources.find((m) => m.category === 0 && m.tag === AppVariables.ProfileImageTag);
            if (m) {

                return thumbnail ? m.path.thumbnail : m.path.static;
            }
            else if (media.count > 0) {

                //  fallback
                return  thumbnail ? media.sources[0].path.thumbnail : media.sources[0].path.static;
            }
        }

        return null;
    }

    /**
     * Generate random number range
     * @param min
     * @param max
     * @returns {Array}
     * @constructor
     */
    static GenerateRange(min,max){

        let numbers = [];
        while (min < max){
            numbers.push(min++);
        }

        return numbers;
    }

    /**
     * Get difference between source and update object
     * @param source
     * @param update
     */
    static  getDifference(source,update){

        let diff = {};
        for(let item in source){

            if(source.hasOwnProperty(item)) {
                if (source[item] != update[item]) {
                    diff[item] = update[item];
                }
            }
        }

        return diff;
    }

    /**
     * Get friendly name for a role
     * @param role
     */
    static formatRole(role) {

        switch (role) {
            case 'admin':
                return 'Administrator';
            case 'fbo':
                return 'Farmer Based Organization';
            case 'owner':
                return 'Tractor Owner';
            case 'farmer':
                return "Farmer";
        }
    }

    /**
     * Exclude filters
     * @param filters
     * @param exclude
     * @returns {*}
     */
    static excludeFilters(filters , exclude = []){
        return filters.filter(x => !exclude.includes(x.key))
    }

    /**
     * Pluralize
     * @param value
     * @param singular
     * @param plural
     * @returns {*}
     */
    static pluralize(value,singular,plural){
        plural = plural || `${singular}s`;
        return isFinite(value) ? ((Number(value) !== 1) ? plural : singular ) : singular;
    }

    /**
     * Gets user name from user payload
     * @param user
     * @returns {*}
     */
    static getUserName(user){

        if(user.admin){
            return `${user.admin.name}`.trim();
        }

        if(user.fbo){
            return user.fbo.name.trim();
        }

        if(user.owner){
            return user.owner.name.trim();
        }

        if(user.farmer){
            return  user.farmer.name.trim();
        }

        if(user.call_center_agent){
            return  user.call_center_agent.name.trim();
        }

        return user.role ? `Unknown-${Utils.ucFirst(user.role)}` : `Unknown-User` ;
    }

    /**
     *  Generate Random Number
     * @param min
     * @param max
     * @returns {number}
     */
    static random(min,max) {
        return Math.floor(Math.random()*(max-min+1)+min);
    }

    /**
     * Formats time zone standard
     * @param date
     */
    static formatTimeZoneStandard(date){
        return momentTimezone(date).tz(momentTimezone.tz.guess()).format(StandardDateFormat);
    }

    //  Format Standard date
    static formatDateStandard(date){
        return moment(date).format(StandardDateFormat);
    }

    //  Format Standard Long date
    static  formatDateLong(date){
        return moment(date).format(StandardDateFormatLong);
    }

    //  Format Standard Short date
    static formatDateShort(date){
        return moment(date).format(StandardDateFormatShort);
    }

    /**
     * Capitalizes the first letter of the string supplied
     * @param str
     * @returns {string}
     */
    static ucFirst(str){
        return str[0].toUpperCase() + str.substring(1).toLowerCase();
    }

    /**
     * Formats the document title
     * @param usePrefix
     * @param title
     */
    static setWindowTitle(title , usePrefix = true ){
        return window.document.title = (usePrefix ? `${AppVariables.AppTitlePrefix}${title}` : title);
    }


}



// WEBPACK FOOTER //
// ./src/common/Utils.js